var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnassignedAssetAssignMapChecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 35,
    viewBox: "0 0 34 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.321045 17.5192C0.321045 8.21899 7.86035 0.679688 17.1606 0.679688C26.4608 0.679688 34.0001 8.21899 34.0001 17.5192C34.0001 26.8194 26.4608 34.3587 17.1606 34.3587C7.86035 34.3587 0.321045 26.8194 0.321045 17.5192Z",
    fill: "#EE9C23",
    fillOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.1545 29.9624L16.5282 29.4593C13.3883 26.9368 11.0088 24.5707 9.43181 22.3587M17.1545 29.9624L9.43181 22.3587M17.1545 29.9624L17.7808 29.4593C20.9207 26.9368 23.3011 24.5709 24.8801 22.3592C26.4647 20.1397 27.3244 17.9277 27.3244 15.7415C27.3244 12.8252 26.3137 10.3767 24.2732 8.48255C22.2683 6.6214 19.8796 5.67969 17.1545 5.67969C14.4278 5.67969 12.0393 6.62131 10.0371 8.48312C7.9999 10.3775 6.99109 12.8257 6.99109 15.7415C6.99109 17.9273 7.84943 20.1391 9.43181 22.3587M17.1545 29.9624L10.2461 21.7782L9.43181 22.3587M18.2057 15.5876C18.2057 15.8575 18.1196 16.0671 17.9093 16.2704L17.9093 16.2705C17.6976 16.4752 17.4654 16.5707 17.1568 16.5707C16.8471 16.5707 16.615 16.4751 16.4044 16.2719C16.1964 16.0711 16.1099 15.8624 16.1099 15.5902C16.1099 15.3165 16.1969 15.1051 16.4057 14.9015C16.6141 14.6983 16.8444 14.6027 17.1541 14.6027C17.4641 14.6027 17.6969 14.6985 17.9086 14.9034C18.1195 15.1077 18.2057 15.3179 18.2057 15.5876Z",
    fill: "#EE9C23",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14592_27121)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.9977 3.39844C22.8084 3.39844 20.22 5.98688 20.22 9.17621C20.22 12.3655 22.8084 14.954 25.9977 14.954C29.1871 14.954 31.7755 12.3655 31.7755 9.17621C31.7755 5.98688 29.1871 3.39844 25.9977 3.39844Z",
    fill: "#354052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7333 9.45577L24.6222 12.3447L29.8222 7.14466L29.0075 6.32422L24.6222 10.7096L22.5479 8.64111L21.7333 9.45577Z",
    fill: "#354052"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 9.45577L24.8889 12.3447L30.0889 7.14466L29.2742 6.32422L24.8889 10.7096L22.8147 8.64111L22 9.45577Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14592_27121"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white",
    transform: "translate(19.5 2.67969)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnassignedAssetAssignMapChecked);
export default __webpack_public_path__ + "static/media/unassigned-asset-assign-map-checked.8e9b8ad0de79cc72a36f170f43258d75.svg";
export { ForwardRef as ReactComponent };